// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.dialog-container {
  padding: 8px 12px 0;
  width: 100%;
  box-sizing: border-box;
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.title {
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 1.35rem;
  color: #0b2d71;
  margin: 0;
}

.dialog-close-button {
  margin-top: -8px;
  margin-right: -8px;
  color: #707070;
}

.middle-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.form-row {
  display: flex;
  gap: 1rem;
}
.form-row .input-container {
  flex: 1 1 0;
}

.input-container {
  display: flex;
  flex-direction: column;
}
.input-container mat-form-field {
  width: 100%;
}
.input-container .prop-label {
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
  color: #333;
}
.input-container .prop-label.required::after {
  content: " *";
  color: #97002e;
}

.api-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  margin-top: 4px;
  border-radius: 4px;
  background-color: #fdecea;
  border: 1px solid #f5c6cb;
  color: #7b1c1c;
  font-size: 0.85rem;
  line-height: 1.4;
}
.api-error mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
  flex-shrink: 0;
}

.lower-container {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
